import { REDIS_ENDPOINT, BASE_URL_OTHERS } from "../constants/settings";
import { myFetch } from "../helpers/myFetch";

export const deleteCache = () => {
  /*BASE_URL_OTHERS.forEach((BASE_URL) => {
    myFetch(`${BASE_URL}/redis`, "DELETE");
  });*/
  return myFetch(`${REDIS_ENDPOINT}`, "DELETE");
};
